import { render } from "./canvans.vue?vue&type=template&id=07008bc8&scoped=true&ts=true"
import script from "./canvans.vue?vue&type=script&lang=ts"
export * from "./canvans.vue?vue&type=script&lang=ts"

import "./canvans.vue?vue&type=style&index=0&id=07008bc8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07008bc8"]])

export default __exports__